import { DetailedHTMLProps, HTMLAttributes } from 'react';
import cn from 'classnames';
import Image from 'next/image';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import {
  Container,
  Htag,
  HtagAlign,
  HtagVariant,
  Paragraph,
} from '../../components';
import styles from './lets-link-branding.module.css';
import letsLogo from '../../public/letslink/branding/lets-logo.png';
import BlockColor from './block-color';

export interface LetsLinkBrandingProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {}

export default function LetsLinkBranding({ className }: LetsLinkBrandingProps) {
  return (
    <section className={cn(className, styles.branding)}>
      <Container variant="container_small">
        <AnimationOnScroll
          delay={0}
          offset={200}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeInDown"
        >
          <Htag
            tag="h1"
            className={styles.title}
            variant={HtagVariant.h1}
            align={HtagAlign.center}
          >
            Branding
          </Htag>
        </AnimationOnScroll>
        <AnimationOnScroll
          delay={0}
          offset={200}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeInDown"
        >
          <div className={styles.branding_logo}>
            <div className={styles.branding_logoStart}>
              <Htag
                tag="h3"
                className={styles.title_second}
                variant={HtagVariant.h3}
                align={HtagAlign.left}
              >
                logo
              </Htag>
              <Paragraph className={styles.text}>
                The Exclusion Zone ensures the legibility and impact of the Logo
                by isolating it from competing visual elements such as text and
                supporting graphics.
              </Paragraph>
              <br />
              <Paragraph className={styles.text}>
                This zone should be considered as the absolute minimum safe
                distance, in most cases the Logo should be given even more room
                to breath.
              </Paragraph>
              <br />
              <Paragraph className={styles.text}>
                The exclusion zone is equal to “L” mark for the logo.
              </Paragraph>
            </div>
            <div className={styles.branding_logoEnd}>
              <Image
                alt="linkapp logo prototype"
                src={letsLogo}
                width={474}
                height={300}
              />
            </div>
          </div>
        </AnimationOnScroll>

        <AnimationOnScroll
          delay={0}
          offset={200}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeInDown"
        >
          <div className={styles.colors}>
            <div className={styles.colors_start}>
              <Htag
                tag="h3"
                className={styles.title_second}
                variant={HtagVariant.h3}
                align={HtagAlign.left}
              >
                colors and font
              </Htag>
              <Paragraph className={styles.text}>
                Three main colours of LinkApp are: Green, Dark Grey and White.
                Use Green for main elements on the screen, CTA buttons, contrast
                elements, illustrations etc. White for the main background. Dark
                Grey for typography.
              </Paragraph>
            </div>
            <div className={styles.colors_end}>
              <BlockColor
                className={styles.colors_green}
                name="Green"
                hex="#44AF50"
                cmyk={{
                  c: 0,
                  m: 0,
                  y: 0,
                  k: 78,
                }}
                rgb={{
                  r: 68,
                  g: 175,
                  b: 80,
                }}
              />
              <BlockColor
                name="Dark Grey"
                hex="#393939"
                cmyk={{
                  c: 0,
                  m: 0,
                  y: 0,
                  k: 78,
                }}
                rgb={{
                  r: 57,
                  g: 57,
                  b: 57,
                }}
              />
            </div>
          </div>
        </AnimationOnScroll>

        <AnimationOnScroll
          delay={0}
          offset={200}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeInDown"
        >
          <div className={styles.typography}>
            <div className={styles.typography_start}>
              <div>Open Sans</div>
              <div>Regular</div>
              <div>Semibold</div>
              <div>Bold</div>
            </div>
            <div className={styles.typography_end}>
              <ul className={styles.typography_list}>
                <li className={styles.typography_item}>
                  <div className={cn(styles.typography_col1, styles.h1)}>
                    H1
                  </div>
                  <div className={styles.typography_col2}>Bold</div>
                  <div className={styles.typography_col3}>24px</div>
                </li>
                <li className={styles.typography_item}>
                  <div className={cn(styles.typography_col1, styles.h2)}>
                    H2
                  </div>
                  <div className={styles.typography_col2}>Semibold</div>
                  <div className={styles.typography_col3}>18px</div>
                </li>
                <li className={styles.typography_item}>
                  <div className={styles.typography_col1}>Button</div>
                  <div className={styles.typography_col2}>Bold</div>
                  <div className={styles.typography_col3}>16px</div>
                </li>
                <li className={styles.typography_item}>
                  <div className={styles.typography_col1}>Body</div>
                  <div className={styles.typography_col2}>Regular</div>
                  <div className={styles.typography_col3}>14px</div>
                </li>
              </ul>
            </div>
          </div>
        </AnimationOnScroll>
      </Container>
    </section>
  );
}
